__turbopack_context__.v({
  "container": "Card-module__86LueG__container",
  "size-small": "Card-module__86LueG__size-small",
});
